import angular from 'angular';

TaskCommentsCtrl.$inject = ['$http', '$filter'];
export default function TaskCommentsCtrl($http, $filter) {

    let STORAGE_KEY = "show_comments_incident_in_comments_task";
    let vm = this;

    vm.task = null;
    vm.currentUserId = Sigo.user.user_id;
    vm.canAddCommentsIncident = Sigo.user.puedeAnyadirComentariosIncidencia;

    vm.enableDisableIncident = enableDisableIncident;
    vm.txtBtnShowIncident = generateMsgBtnShowIncident(vm.showIncident);
    vm.update = update;

    loadTask(vm.taskId);

    function loadTask(taskId) {
        let URL_TASK = Sigo.var.path + '/api/v1/tareas/' + taskId;

        $http.get(URL_TASK).then((response) => {
            vm.task = response.data;
            loadIncident(vm.task.incidencia_id);
        });
    }

    vm.canViewCommentsIncident = false;
    function loadIncident(incidentId) {
        let URL_INCIDENT = Sigo.var.path + '/api/v1/incidencias/' + incidentId;

        $http.get(URL_INCIDENT).then(() => {
            vm.canViewCommentsIncident = Sigo.user.puedeVerComentariosIncidencia;

            if (vm.canViewCommentsIncident) {
                let storageValue = window.localStorage.getItem(STORAGE_KEY);
                vm.showIncident = storageValue != null && storageValue == "true" ? true : false;
                vm.txtBtnShowIncident = generateMsgBtnShowIncident(vm.showIncident);
            } else
                vm.showIncident = false;
        });
    }

    function enableDisableIncident() {
        if (!vm.canViewCommentsIncident) return;

        vm.showIncident = !vm.showIncident;
        vm.txtBtnShowIncident = generateMsgBtnShowIncident(vm.showIncident);
        window.localStorage.setItem(STORAGE_KEY, vm.showIncident);
    }

    function generateMsgBtnShowIncident(showIncident) {
        return ucfirst(
            (showIncident
                ? ($filter('lang')('nombres.ocultar', 'get')) : ($filter('lang')('nombres.mostrar', 'get'))) + " "
            + $filter('lang')('nombres.comentario', 'choice', 2) + " "
            + $filter('lang')('nombres.incidencia', 'choice', 1)
        );
    }

    function update() {
        vm.task = null;
        loadTask(vm.taskId);
    }
}